import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';
import { categoryMap } from '@/mocks/categories';

export default function ArticlesSection() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              最新的91c使用技巧、功能解析与行业洞察
            </p>
          </div>
          <Link
            to="/category/tutorials"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 transition-all duration-300 flex flex-col"
            >
              <span className="inline-block px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full w-fit">
                {categoryMap[article.category] || article.category}
              </span>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-300 line-clamp-2 leading-snug">
                {article.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                {article.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                <span>{article.date}</span>
                <span className="text-foreground-200">·</span>
                <span>{article.readTime}阅读</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/tutorials"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}